import { render, staticRenderFns } from "./ContactInformationForm.vue?vue&type=template&id=44fdaf4c&"
import script from "./ContactInformationForm.vue?vue&type=script&lang=js&"
export * from "./ContactInformationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VForm,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/working_dir/management-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44fdaf4c')) {
      api.createRecord('44fdaf4c', component.options)
    } else {
      api.reload('44fdaf4c', component.options)
    }
    module.hot.accept("./ContactInformationForm.vue?vue&type=template&id=44fdaf4c&", function () {
      api.rerender('44fdaf4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Shared/Forms/ContactInformationForm.vue"
export default component.exports